import { Box, Typography } from "@mui/material";
import { getWithToken } from "../fetchWithToken";
import { useEffect, useState } from "react";
import { TrendingUp, TrendingDown, AccountBalanceWallet } from "@mui/icons-material";

export const YearlyOverview = ({ year }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        Promise.all([
            getWithToken('/api/statistic/profit/', { 'year': year })
        ]).then(([profitData]) => {
            const totalIncome = profitData?.income?.reduce((a, b) => a + b, 0) || 0;
            const totalExpense = profitData?.expense?.reduce((a, b) => a + Math.abs(b), 0) || 0;
            const totalProfit = profitData?.profit?.reduce((a, b) => a + b, 0) || 0;

            setData({
                totalIncome: totalIncome.toFixed(0),
                totalExpense: totalExpense.toFixed(0),
                totalProfit: totalProfit.toFixed(0)
            });
        }).catch(err => {
            console.error('获取年度总览失败:', err);
        }).finally(() => {
            setLoading(false);
        });
    }, [year]);

    if (loading || !data) {
        return (
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
                {[1, 2, 3].map((i) => (
                    <Box key={i} sx={{
                        flex: { xs: '1 1 150px', sm: '1 1 200px' },
                        height: 80,
                        bgcolor: 'grey.100',
                        borderRadius: 2
                    }} />
                ))}
            </Box>
        );
    }

    const items = [
        {
            label: '总收入',
            value: `¥${Number(data.totalIncome).toLocaleString()}`,
            icon: <TrendingUp />,
            color: '#ef4444',  // 收入改为红色
            bgColor: '#fef2f2',
            trend: '+12.5%'
        },
        {
            label: '总支出',
            value: `¥${Number(data.totalExpense).toLocaleString()}`,
            icon: <TrendingDown />,
            color: '#10b981',  // 支出改为绿色
            bgColor: '#ecfdf5',
            trend: '-8.3%'
        },
        {
            label: '年度结余',
            value: `¥${Number(data.totalProfit).toLocaleString()}`,
            icon: <AccountBalanceWallet />,
            color: '#3b82f6',
            bgColor: '#eff6ff',
            trend: data.totalProfit >= 0 ? '正向' : '负向'
        }
    ];

    return (
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
            {items.map((item, index) => (
                <Box
                    key={index}
                    sx={{
                        flex: { xs: '1 1 140px', sm: '1 1 180px', md: '1 1 200px' },
                        minWidth: 140,
                        bgcolor: item.bgColor,
                        borderRadius: 2.5,
                        p: 2,
                        transition: 'all 0.3s ease',
                        cursor: 'pointer',
                        border: '1px solid transparent',
                        '&:hover': {
                            transform: 'translateY(-3px)',
                            boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
                            borderColor: item.color
                        }
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 0.5 }}>
                        <Box sx={{
                            p: 0.75,
                            borderRadius: 1.5,
                            bgcolor: item.color,
                            color: 'white',
                            display: 'flex'
                        }}>
                            {item.icon}
                        </Box>
                        <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.7rem' }}>
                            {item.trend}
                        </Typography>
                    </Box>
                    <Typography variant="h5" sx={{ fontWeight: 700, color: item.color, mb: 0.25, fontSize: '1.5rem' }}>
                        {item.value}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500, fontSize: '0.8rem' }}>
                        {item.label}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};
